export default __webpack_public_path__ + "static/media/ico-sq-3-goodhealth.0160d62e.svg";